module.exports = __webpack_public_path__ + "img/ic_logbook.cb3b96c5.svg";